import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CompetitorTypes } from "~enums/competitorTypes";
import { useApi } from "~hooks/apiHooks/useApi";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useDeletePlacing = () => {
  const { sport, organizationId, seasonId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { competitorType } = useSportConfiguration();

  const entrantUrlPart = competitorType === CompetitorTypes.Person ? "persons" : "entities";

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (placingsId: string) => {
      return await request(`${sport}/o/${organizationId}/seasons/${entrantUrlPart}/placings/${placingsId}`, {
        method: "DELETE",
      });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        await queryClient.invalidateQueries({
          queryKey: ["final-standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
